const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
function SvgSdg17(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "500px",
    height: "500px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#0f366b",
    d: "M -0.5,-0.5 C 166.167,-0.5 332.833,-0.5 499.5,-0.5C 499.5,166.167 499.5,332.833 499.5,499.5C 332.833,499.5 166.167,499.5 -0.5,499.5C -0.5,332.833 -0.5,166.167 -0.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fbfbfc",
    d: "M 232.5,57.5 C 276.95,53.4734 310.45,70.4734 333,108.5C 334.798,112.422 336.298,116.422 337.5,120.5C 383.745,124.928 413.579,149.261 427,193.5C 434.113,231.829 423.113,263.829 394,289.5C 401.828,327.986 391.662,360.819 363.5,388C 334.604,410.706 302.604,416.372 267.5,405C 261.096,402.254 254.929,399.087 249,395.5C 210.141,418.179 172.308,416.679 135.5,391C 104.728,363.607 93.8944,329.773 103,289.5C 71.7247,262.212 61.058,228.212 71,187.5C 86.3034,146.358 115.803,124.024 159.5,120.5C 164.693,103.969 174.027,90.1353 187.5,79C 200.852,68.2774 215.852,61.1107 232.5,57.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#11366b",
    d: "M 235.5,76.5 C 265.394,73.7321 289.894,83.7321 309,106.5C 312.643,111.455 315.476,116.788 317.5,122.5C 285.933,128.562 262.766,145.896 248,174.5C 233.883,145.691 211.05,128.357 179.5,122.5C 186.708,104.784 199.041,91.6176 216.5,83C 222.882,80.622 229.215,78.4553 235.5,76.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#11366b",
    d: "M 146.5,140.5 C 148.833,140.5 151.167,140.5 153.5,140.5C 151.24,172.36 161.24,199.527 183.5,222C 151.477,227.028 127.31,243.528 111,271.5C 83.945,243.209 79.2784,211.543 97,176.5C 109.197,158.454 125.697,146.454 146.5,140.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#10366b",
    d: "M 342.5,140.5 C 373.233,145.106 394.4,161.773 406,190.5C 413.712,215.789 410.046,239.122 395,260.5C 392.353,264.314 389.187,267.647 385.5,270.5C 369.008,243.245 345.008,226.912 313.5,221.5C 335.849,199.117 345.516,172.117 342.5,140.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#11366b",
    d: "M 320.5,140.5 C 321.5,140.5 322.5,140.5 323.5,140.5C 326.629,174.283 313.963,200.116 285.5,218C 277.284,222.278 268.618,225.111 259.5,226.5C 256.027,189.603 270.694,162.77 303.5,146C 309.146,143.718 314.813,141.885 320.5,140.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#12376b",
    d: "M 172.5,140.5 C 205.176,146.676 226.342,165.676 236,197.5C 237.359,207.109 237.859,216.776 237.5,226.5C 212.301,222.81 193.468,209.81 181,187.5C 173.733,172.662 170.9,156.996 172.5,140.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#818ead",
    d: "M 186.5,241.5 C 189.314,240.835 192.314,240.502 195.5,240.5C 200.424,240.354 205.091,241.021 209.5,242.5C 201.858,241.737 194.191,241.403 186.5,241.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#11366b",
    d: "M 287.5,240.5 C 321.015,237.014 347.182,249.014 366,276.5C 367.301,278.402 367.968,280.402 368,282.5C 331.54,298.458 300.207,291.458 274,261.5C 271.75,257.332 269.25,253.332 266.5,249.5C 267.936,248.066 269.602,246.9 271.5,246C 277.063,244.454 282.396,242.62 287.5,240.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#12366b",
    d: "M 186.5,241.5 C 194.191,241.403 201.858,241.737 209.5,242.5C 214.897,243.683 220.23,245.183 225.5,247C 227.223,247.523 228.556,248.523 229.5,250C 214.376,276.576 191.376,290.409 160.5,291.5C 148.733,291.131 137.733,288.131 127.5,282.5C 140.403,259.207 160.069,245.54 186.5,241.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#11366b",
    d: "M 246.5,263.5 C 249.263,263.744 251.429,265.077 253,267.5C 271.351,290.338 275.684,315.671 266,343.5C 262.318,353.67 256.484,362.337 248.5,369.5C 229.607,349.974 222.44,326.641 227,299.5C 230.348,285.688 236.848,273.688 246.5,263.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#10366b",
    d: "M 204.5,299.5 C 205.675,299.281 206.675,299.614 207.5,300.5C 203.265,331.518 211.598,358.518 232.5,381.5C 196.849,400.03 165.016,394.697 137,365.5C 122.443,346.61 116.943,325.276 120.5,301.5C 146.599,312.837 172.932,313.337 199.5,303C 201.431,302.098 203.097,300.931 204.5,299.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#11376b",
    d: "M 288.5,300.5 C 288.56,299.957 288.893,299.624 289.5,299.5C 317.503,313.403 345.837,314.069 374.5,301.5C 380.177,330.024 372.177,354.191 350.5,374C 329.691,390.031 306.357,395.031 280.5,389C 274.743,387.287 269.41,384.787 264.5,381.5C 285.311,358.309 293.311,331.309 288.5,300.5 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSdg17);
export default __webpack_public_path__ + "static/media/sdg17.67e7d492f2a20db087eb22b77e02d8b4.svg";
export { ForwardRef as ReactComponent };